module.exports = __webpack_public_path__ + "img/H1.8ddd07d6.png";